import { clampResourceScheduleMoveSlotIndex } from './resourceScheduleSlotMath';

export interface ResourceScheduleMovePreview<ResourceId extends string | number = string | number> {
  resourceId: ResourceId;
  resourceIndex: number;
  slotIndex: number;
  durationSlots: number;
}

interface ResolveResourceScheduleMovePreviewOptions<ResourceId extends string | number = string | number> {
  startSlotIndex: number;
  durationSlots: number;
  resourceIndex: number;
  resourceId: ResourceId;
  deltaX: number;
  deltaY: number;
  slotWidth: number;
  rowHeight: number;
  visibleSlotCount: number;
  resourceIds: readonly ResourceId[];
}

export function resolveResourceScheduleMovePreview<ResourceId extends string | number = string | number>({
  startSlotIndex,
  durationSlots,
  resourceIndex,
  resourceId,
  deltaX,
  deltaY,
  slotWidth,
  rowHeight,
  visibleSlotCount,
  resourceIds,
}: ResolveResourceScheduleMovePreviewOptions<ResourceId>): ResourceScheduleMovePreview<ResourceId> {
  const deltaSlots = Math.round(deltaX / slotWidth);
  const deltaRows = Math.round(deltaY / rowHeight);
  const slotIndex = clampResourceScheduleMoveSlotIndex(
    startSlotIndex,
    deltaSlots,
    visibleSlotCount,
    durationSlots,
  );

  if (resourceIds.length === 0) {
    return {
      resourceId,
      resourceIndex,
      slotIndex,
      durationSlots,
    };
  }

  const nextResourceIndex = Math.max(0, Math.min(resourceIds.length - 1, resourceIndex + deltaRows));

  return {
    resourceId: resourceIds[nextResourceIndex] ?? resourceId,
    resourceIndex: nextResourceIndex,
    slotIndex,
    durationSlots,
  };
}